import { z } from 'zod';
export const registerSchema = z.object({
    email: z.string().email('Invalid email address'),
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(128, 'Password must not exceed 128 characters'),
    displayName: z.string().min(1, 'Display name is required').max(100),
});
export const loginSchema = z.object({
    email: z.string().email('Invalid email address'),
    password: z.string().min(1, 'Password is required'),
});
export const inviteUserSchema = z.object({
    email: z.string().email('Invalid email address'),
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(128, 'Password must not exceed 128 characters'),
    displayName: z.string().min(1, 'Display name is required').max(100),
    role: z.enum(['admin', 'user']).default('user'),
});
export const updateUserRoleSchema = z.object({
    role: z.enum(['admin', 'user']),
});
export const resetPasswordSchema = z.object({
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(128, 'Password must not exceed 128 characters'),
});
export const adminUserQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    search: z.string().optional(),
    role: z.enum(['admin', 'user']).optional(),
    sortBy: z
        .enum(['displayName', 'email', 'role', 'aiTier', 'createdAt', 'lastLoginAt', 'itemCount', 'totalValue'])
        .default('createdAt'),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
});
export const adminOfferQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    status: z.enum(['pending', 'accepted', 'declined', 'withdrawn', 'all']).default('all'),
    search: z.string().optional(),
    sortBy: z.enum(['createdAt', 'status', 'moneyAmount']).default('createdAt'),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
});
//# sourceMappingURL=auth.js.map